export default __webpack_public_path__ + "static/logo-3140f1c4ac72ba43c94e8567f22646bd.png";